export class Address {

    street: string;
    number: string;
    premise: string;
    sublocalities: string[];
    zip: string;
    city: string;
    area: string;
    country: string;
    description: string;

    constructor() {
        this.sublocalities = ['', '', '', ''];
    }

    get sublocality() {
        return this.sublocalities.filter(l => !!l).join(' ');
    }
}

export class Coords {
    lat: number;
    lng: number;
}
